<template>
    <div>
        <RouteCountryInfo v-if="showOverviewInfo" :countryInfo="countryInfo" :shortInfo="true" :route="route" />

        <div class="sidebar-detail__section">
            <!-- routingHints -->
            <ListInfoItem v-if="route.routingHints && route.routingHints.length" :hasContent="false" :centerVertically="false" :overflowGradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon list-info-item__summary__icon--no-margin-top"><IconAlert /></icon>
                    <!-- <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Vignettenpflicht</div>
                    </div> -->
                    <div class="list-info-item__section">
                        <div class="list-info-item__row ui-spread-center-vertically" :class="{ 'list-info-item__row--space-top' : index > 0 }" v-for="(hint, index) in route.routingHints" :key="index">
                            <div>
                                <div class="h4">{{ hint.title }}</div>
                                <div class="copy-light" v-html="hint.text"></div>
                            </div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>


            <div class="sidebar__section sidebar-detail__subtitle bold-small-label" :class="{ 'sidebar-detail__subtitle--space-top' : route.routingHints && route.routingHints.length }" v-if="hasRouteDetails">Routendetails</div>

            <!-- Vignettes -->
            <ListInfoItem v-if="route.tolls && route.tolls.vignette && route.tolls.vignette.length" :hasContent="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconVignette /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Vignettenpflicht</div>
                    </div>
                </template>
                <template slot="content">
                    <div class="list-info-item__section">
                        <div class="list-info-item__row list-info-item__row--space-top list-info-item__row--link ui-spread-center-vertically" v-for="vignette in route.tolls.vignette" :key="vignette.countryCode" @click="tollClickHandler(vignette.countryCode)">
                            <div>
                                <div class="copy">{{ vignette.country }}</div>
                                <div class="copy-light">Vignettenpflicht auf {{ vignette.distance }}</div>
                            </div>
                            <icon v-if="!showOverviewInfo" class="list-info-item__row__arrow" :width="20" :height="20"><IconChevronRight /></icon>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Tolls -->
            <ListInfoItem v-if="route.tolls && route.tolls.tollSumEuro" :hasContent="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconToll /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Maut Gesamt</div>
                        <div class="list-info-item__summary__text copy-light">{{ route.tolls.tollSumEuro }}</div>
                    </div>
                </template>
                <template slot="content" v-if="route.tolls.toll && route.tolls.toll.length">
                    <div class="list-info-item__section">
                        <div class="list-info-item__row list-info-item__row--space-top list-info-item__row--link ui-spread-center-vertically" v-for="toll in route.tolls.toll" :key="toll.countryCode" @click="tollClickHandler(toll.countryCode)">
                            <div>
                                <div class="copy">{{ toll.country }}</div>
                                <div class="copy-light">
                                    {{ toll.amountEuro }}{{ toll.amountCountry ? ` (${toll.amountCountry})` : '' }}
                                </div>
                            </div>
                            <icon v-if="!showOverviewInfo" class="list-info-item__row__arrow" :width="20" :height="20"><IconChevronRight /></icon>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Gas Price -->
            <ListInfoItem v-if="route.gasPrice" :hasContent="true" :centerVertically="true" :overflowGradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconGasStation /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Spritkosten</div>
                        <div class="list-info-item__summary__text copy-light">
                            <span v-if="route.fullGasConsumption" class="dot-divider dot-divider--info">
                                {{ route.fullGasConsumption }} l Verbrauch
                            </span>
                            <span class="dot-divider dot-divider--info">
                                ca. {{ route.gasPrice }}
                            </span>
                        </div>
                    </div>
                    <GasConsumptionPopup class="list-info-item__summary__edit" :route-mode="route.mode" />
                </template>
            </ListInfoItem>

            <!-- Fare -->
            <ListInfoItem v-if="route.fare" :hasContent="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPayment /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Öffi-Ticket</div>
                        <div class="list-info-item__summary__text copy-light">ca. {{ route.fare }}</div>
                    </div>
                </template>
            </ListInfoItem>


            <!-- Transitions -->
            <ListInfoItem v-if="route.transitions" :hasContent="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPublicTransport /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Umstiege</div>
                        <div class="list-info-item__summary__text copy-light">{{ route.transitions }} x umsteigen</div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Eco Route -->
            <ListInfoItem v-if="route.ecoSavings" :hasContent="true" :centerVertically="true" :overflowGradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon green"><IconLeaf /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">EcoRoute</div>
                        <div class="list-info-item__summary__text copy-light">
                            Sparsamste Route im Vergleich
                        </div>
                    </div>
                    <InfoPopup class="list-info-item__summary__edit" title="Weitere Infos zur Öko-Route" text="Die Öko-Route ist im Vergleich zu den Routenalternativen die Route mit dem geringsten Verbrauch und wird deshalb als ökologische Routenalternative ausgegeben. Zusammengesetzt wird sie aus Faktoren wie Entfernung, Durchschnitts­geschwindigkeit, Vermeidung von Stop- und Go-Verkehr und Streckenführung. Der tatsächliche Verbrauch ist dabei stark abhängig von individuellem Fahrverhalten und Fahrzeug. Hier finden Sie viele weitere <a href='https://www.oeamtc.at/thema/tanken/'>Tipps zum Spritsparen</a>" />
                </template>
            </ListInfoItem>

            <!-- Shortterm Parking Zone -->
            <ListInfoItem v-if="routeShortTermParkingZone[route.mode]" :clickable="true" @click.native="parkingClickHandler" :loading="parkingZoneUrlLoading">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconParking /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Parken</div>
                        <div class="list-info-item__summary__text copy-light">Das Ziel ist in einer Kurzparkzone</div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Greenzones -->
            <ListInfoItem v-if="route.greenzones" :hasContent="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconGreenzone /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Umweltzonen</div>
                    </div>
                </template>
                <template slot="content">
                    <div class="list-info-item__section">
                        <div class="list-info-item__row list-info-item__row--space-top" v-for="country in Object.keys(route.greenzones)" :key="country">
                            <div>
                                <div class="list-info-item__row--medium-space copy">{{ country }}</div>
                                <div class="list-info-item__row--medium-space copy-light ui-spread-center-vertically ui-cursor-pointer" v-for="greenzone in route.greenzones[country]" :key="greenzone.id" @click="greenzoneClickHandler(greenzone.id)">
                                    {{ greenzone.name }}
                                    <icon class="list-info-item__row__arrow" :width="20" :height="20"><IconChevronRight /></icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Personal Note -->
            <ListInfoItem v-if="isSavedRoute && savedRouteInfo.note" :overflowGradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconEditNote /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Persönliche Notiz</div>
                        <div class="copy-light">{{savedRouteInfo.note}}</div>
                    </div>
                </template>
            </ListInfoItem>

            <NoResultsMessage v-if="hasNoResults" :face="false" :icon="true" type="NO_ROUTE_OVERVIEW">
                <IconCheckGreen slot="icon" />
            </NoResultsMessage>

        </div>

        <!-- Country operation messages -->
        <RouteMessageAlert  v-if="showOverviewInfo && route.operationMessages" :route-operation-messages="route.operationMessages"></RouteMessageAlert>

        <RouteTrafficMessages  v-if="showTrafficMessages" :route="route" @trafficMessagesLoaded="trafficMessagesLoadedHandler" />
        
    </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { TRAFFIC_TRANSPORT_MODES } from '@/data/transportModesTypes'
import ListInfoItem from '@/components/ListInfoItem.vue'
import NoResultsMessage from '@/components/NoResultsMessage.vue'
import RouteTrafficMessages from '@/components/RouteTrafficMessages.vue'
import RouteCountryInfo from '@/components/RouteCountryInfo.vue'
import RouteMessageAlert from '@/components/RouteMessageAlert.vue'
import Icon from '@/components/Icon.vue'
import IconCheckGreen from '@/components/icons/IconCheckGreen.vue'
import IconVignette from '@/components/icons/IconVignette.vue'
import IconToll from '@/components/icons/IconToll.vue'
import IconParking from '@/components/icons/IconParking.vue'
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
import IconPayment from '@/components/icons/IconPayment.vue'
import IconPublicTransport from '@/components/icons/IconPublicTransport.vue'
import IconEditNote from '@/components/icons/IconEditNote.vue'
import IconGreenzone from '@/components/icons/IconGreenzone.vue'
import IconAlert from '@/components/icons/IconAlert.vue'
import IconGasStation from '@/components/icons/IconGasStation.vue'
import IconLeaf from '@/components/icons/IconLeaf.vue'
import GasConsumptionPopup from '@/components/GasConsumptionPopup.vue';
import InfoPopup from '@/components/InfoPopup.vue';

export default {
    components: {
    ListInfoItem,
    NoResultsMessage,
    Icon,
    IconCheckGreen,
    IconVignette,
    IconToll,
    IconParking,
    IconChevronRight,
    IconEditNote,
    IconPayment,
    IconPublicTransport,
    IconGreenzone,
    IconAlert,
    IconGasStation,
    IconLeaf,
    RouteTrafficMessages,
    RouteCountryInfo,
    RouteMessageAlert,
    GasConsumptionPopup,
    InfoPopup
},
    props: {
        route: {
            type: Object,
            default: () => {}
        },
        countryInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            parkingZoneUrlLoading: false,
            overviewInfoMode: ['FOOT', 'BIKE', 'PARK_AND_RIDE', 'BIKE_AND_RIDE', 'SHARING'],
            trafficMessagesLoaded: false,
            trafficMessagesAvailable: false
        }
    },
    computed: {
        ...mapGetters(['loadingPOIs', 'routeShortTermParkingZone', 'isSavedRoute', 'savedRouteInfo', 'gasConsumptionSettings']),
        showTrafficMessages() {
            return  TRAFFIC_TRANSPORT_MODES.includes(this.route.mode);
        },
        showOverviewInfo() {
            return this.overviewInfoMode.includes(this.route.mode);
        },
        hasRouteDetails() {
            return (this.route.tolls && (this.route.tolls.vignette || this.route.tolls.tollSumEuro)) || this.routeShortTermParkingZone[this.route.mode] || this.route.fare || this.route.transitions || this.route.greenzones
        },
        hasTrafficMessages() {
            return this.showTrafficMessages && this.trafficMessagesLoaded && this.trafficMessagesAvailable
        },
        hasNoResults() {
           if(this.showOverviewInfo) return !this.hasRouteDetails && !this.countryInfo
           if(this.showTrafficMessages) return !this.hasRouteDetails && !this.hasTrafficMessages && this.trafficMessagesLoaded
           return !this.hasRouteDetails
        }
    },
    methods: {
        tollClickHandler(countryCode) {
            this.goToCountryInfo(countryCode);
        },
        tollsClickHandler() {
            this.goToCountryInfo();
        },
        parkingClickHandler() {
            this.openShorttermParkingDetail()
        },
        greenzoneClickHandler(id) {
            this.openGreenzoneDetail(id)
        },
        trafficMessagesLoadedHandler(trafficMessagesAvailable) {
            this.trafficMessagesLoaded = true
            this.trafficMessagesAvailable = trafficMessagesAvailable
        },
        goToCountryInfo(countryCode) {
            this.$emit('change-tab', {
                tab: 'country-info',
                action: 'showTolls',
                country: countryCode,
            });
        },
        openShorttermParkingDetail() {
            const parkingZoneId = this.routeShortTermParkingZone[this.route.mode].id
            if(parkingZoneId) {
                this.$store.commit('setCustomActivePoiType', 'carParks');
                this.$store.commit('setActivePoiId', parkingZoneId);
                this.$store.commit('setCustomActivePoiSubType', 'shorttermparking');
            }
        },
        openGreenzoneDetail(id) {
            this.$store.commit('setCustomActivePoiType', 'greenzone');
            this.$store.commit('setActivePoiId', id);
        },
    },
}
</script>

<style lang="scss">
</style>